module.exports = __webpack_public_path__ + "img/benefit-logo-2.b240f339.svg";